/**
 * sds-scroll-reveal.js
 * Lightweight IntersectionObserver-based scroll-reveal.
 * Mark any element with class "sds-reveal" (optionally "sds-reveal--scale")
 * and it will fade + slide into view when it enters the viewport.
 * Works for Resources page and Contact Us page.
 */
(function () {
  'use strict';

  function initReveal() {
    var elements = document.querySelectorAll('.sds-reveal');
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback: show all immediately
      elements.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -48px 0px'
      }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  // Run on DOMContentLoaded or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

  // Re-run after Shopify section re-renders (theme editor live preview)
  document.addEventListener('shopify:section:load', function () {
    // Reset any newly added elements
    var elements = document.querySelectorAll('.sds-reveal:not(.is-visible)');
    if (!elements.length) return;
    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -48px 0px' });
    elements.forEach(function (el) { obs.observe(el); });
  });
})();
